import React from 'react'
import { Link } from 'react-router-dom'
import SmallLogo from '../../assets/logo-white-no-background.png'
import { MutableRefObject } from 'react'

interface HomeNavbarProps {
  whyStorageWalk: MutableRefObject<HTMLDivElement | null | undefined>
  demo: MutableRefObject<HTMLDivElement | null | undefined>
  about: MutableRefObject<HTMLDivElement | null | undefined>
  pricing: MutableRefObject<HTMLDivElement | null | undefined>
  faq: MutableRefObject<HTMLDivElement | null | undefined>
}

export default function HomeNavbar({ whyStorageWalk, demo, about, pricing, faq }: HomeNavbarProps) {
  return (
    <nav className="w-full bg-primary-dark text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img src={SmallLogo} alt="Site Walk Logo" className="h-12" />
        </Link>
        <div className="flex space-x-4">
          <button onClick={() => whyStorageWalk.current?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-gray-300 text-lg font-medium">
            Why Storage Walk
          </button>
          <button onClick={() => demo.current?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-gray-300 text-lg font-medium">
            Demo
          </button>
          <button onClick={() => about.current?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-gray-300 text-lg font-medium">
            About
          </button>
          <button onClick={() => pricing.current?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-gray-300 text-lg font-medium">
            Pricing
          </button>
          <button onClick={() => faq.current?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-gray-300 text-lg font-medium">
            FAQ
          </button>
          <Link to="/login" className="hover:text-gray-300 text-lg font-medium">Login</Link>
          <Link to="/register" className="hover:text-gray-300 text-lg font-medium">Register</Link>
        </div>
      </div>
    </nav>
  )
}